import { Outlet } from '@tanstack/react-router';

import { useRealtimeInvalidation } from '../api/use-realtime.js';
import { useAuthStore } from '../auth/auth-store.js';

import { Sidebar } from './sidebar.js';

import './layout.css';

/**
 * Базовый layout admin SPA: вертикальный GlobalSidebar (52px) + main content.
 * Inbox/Settings внутри Outlet выстраивают свои подколонки самостоятельно.
 *
 * Реалтайм-подписка живёт ИМЕННО ЗДЕСЬ (а не в inbox-page): иначе на любой
 * странице кроме /inbox WS не подключается → PresenceService.addSocket не
 * вызывается → user.status в БД не становится online → весь UI показывает
 * оператора offline.
 */
export function ThreeColumnLayout(): JSX.Element {
  const workspaceSlug = useAuthStore((s) => s.user?.workspaceSlug);
  useRealtimeInvalidation(workspaceSlug);
  return (
    <div className="inbx-layout">
      <Sidebar />
      <main className="inbx-layout__main">
        <Outlet />
      </main>
    </div>
  );
}
